import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getAllBlogEntries, getAllAlbums, getImagesByAlbum } from "../../api/requests";
import { Card, Container, Spinner, Button } from "react-bootstrap";

const BlogDetail = () => {
    const { id } = useParams();
    const [entry, setEntry] = useState(null);
    const [album, setAlbum] = useState(null);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const entries = await getAllBlogEntries();
            const found = (Array.isArray(entries) ? entries : (entries?.results || [])).find(e => String(e.id) === String(id));
            setEntry(found);

            if (found && found.album) {
                const albums = await getAllAlbums();
                const albumObj = (Array.isArray(albums) ? albums : (albums?.results || [])).find(a => a.id === found.album);
                setAlbum(albumObj);

                const imgs = await getImagesByAlbum(found.album);
                setImages(imgs || []);
            }
            setLoading(false);
        };
        fetchData();
    }, [id]);

    if (loading) {
        return <div style={{textAlign: "center", marginTop: 40}}><Spinner animation="border" /></div>;
    }
    if (!entry) {
        return <Container><Card body>Blogeintrag nicht gefunden.</Card></Container>;
    }

    return (
        <Container>
            <Card>
                <Card.Header>
                    <h2>{entry.title}</h2>
                </Card.Header>
                <Card.Body>
                    <div style={{ color: "#888", fontSize: 15, marginBottom: 8 }}>
                        {entry.date && new Date(entry.date).toLocaleDateString()}
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <strong>Text:</strong>
                        <div className="plain-text">{entry.text}</div>
                    </div>
                    {album && (
                        <div style={{ marginBottom: 16 }}>
                            <strong>Album: </strong>
                            <Link to={`/album/${album.id}`}>{album.title}</Link>
                            <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
                                {images.map(img => (
                                    <img
                                        key={img.id}
                                        src={img.image}
                                        alt={img.title}
                                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8, background: "#eee" }}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                    <Button as={Link} to="/tsc-blog" variant="secondary">
                        Zurück zum Blog
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default BlogDetail;
